var modalData = {
  personA: [{
      project: "化妝品",
      text: "姐在江湖走，補妝三寶要有 (口紅、眼線、氣墊粉餅)"
    },
    {
      project: "防身噴霧器",
      text: "防暗巷歹徒、防應酬色鬼、防職災尋仇"
    },
    {
      project: "香水",
      text: "男友送的名牌香水"
    },
    {
      project: "薄荷錠",
      text: "菜鳥辭不達意，老鳥言不由衷，薄荷提神醒腦，保證藥到病除"
    },
    {
      project: "番茄汁",
      text: "應酬喝了再上，解酒有備無患"
    },
    {
      project: "隨身藥袋",
      text: "三餐不定，頭疼胃疼肚子疼"
    },
    {
      project: "手機",
      text: "錄音、拍照、筆記、Po文 ，沒有手機應戰萬萬不能"
    },
    {
      project: "筆記本",
      text: "命可以不要，它不能不見；每週報六題，娛樂祕辛一網打盡"
    },
    {
      project: "含淚鳳梨酥",
      text: "記者忌諱「旺旺來」，沒題目只好含恨吞"
    },
    {
      project: "維他命C",
      text: "助免疫力，治違心病"
    },
    {
      project: "餅乾",
      text: "中午趕跑記者會，趁空檔先墊個胃"
    },
    {
      project: "腳架",
      text: "角度偏、訊號卡，畫面抖、網友都譙！記者必備直播不求人"
    }
  ],
  personASecret: [{
    project: "法院傳票",
    text: "傳聞道，哪個週刊記者身上沒背幾條官司，面對報題及點閱壓力，寫新聞一個不留神，被告是家常便飯"
  }],
  personB: [{
      project: "咖啡",
      text: "A coffee a day keeps the burden at bay."
    },
    {
      // 這筆資料實際上會由「specialChangePersonB2();」蓋掉。
      project: "99% 巧克力",
      text: "有苦在心口難開 99%巧克力都是甜的"
    },
    {
      project: "藥罐",
      text: "舶來營養品，顧胃顧身顧目珠"
    },
    {
      project: "香氛噴霧",
      text: "招財進寶，能量一噴，好運UPUP"
    },
    {
      project: "手機",
      text: "羅姊的本命，韓流帥大叔一眼望千憂"
    },
    {
      project: "御守",
      text: "佛祖耶穌觀世音，能開運的都來一打"
    },
    {
      project: "喉糖八仙果",
      text: "發怒飆罵後，搶救喉嚨燒聲"
    },
    {
      project: "精油滾珠棒",
      text: "會議太傷神，精油滾珠棒別忘"
    },
    {
      project: "唇蜜",
      text: "ㄉㄨㄞㄉㄨㄞ豐唇，留住膠原蛋白"
    },
    {
      project: "名牌護手霜",
      text: "靠手吃飯的，保養不能少"
    },
    {
      project: "筆記本",
      text: "歷年八卦頭條，噓 ~ 別問很可怕"
    }
  ],
  personBSecret: [{
    project: "禮物盒",
    text: "週刊記者不能利用職權收取利益，若收到經紀人、藝人、電影公司老闆送禮盒，通常為避嫌，會公開發送，與同事們有福同享"
  }],
  personC: [{
      project: "包葉仔尬蠻牛",
      text: "提神必備！駕駛解悶不能少"
    },
    {
      project: "針孔攝影黑框眼鏡",
      text: "你是我的眼～如果我能看得見，就能跟你到處遨遊，驚喜地從背後給你一則頭條"
    },
    {
      project: "帽子口罩",
      text: "為捕捉獨家畫面，喬裝打工仔避人耳目"
    },
    {
      project: "偽裝手錶夜視針孔攝影機",
      text: "再給我兩分鐘～讓我清記憶體接USB"
    },
    {
      project: "鈕扣造型針孔攝影機",
      text: "襯衫鈕扣就是神隊友，迅速捕捉畫面全靠它"
    },
    {
      project: "寬口飲料瓶",
      text: "膀胱救星！車上小解好朋友，寬瓶口最好用，你知道的！"
    }
  ],
  personCSecret: [{
      project: "愛心宵夜",
      text: "緊迫盯人蹲點跟拍，偶爾也會遇見友善藝人，敲車窗比手勢說聲「辛苦了」，送宵夜送飲料揪感心"
    },
    {
      project: "診斷證明書",
      text: "狗仔明星相愛相殺上演全武行，記者行規被打不能還手，一求攝影畫面，二為保護自身權益，去醫院驗傷也就習慣成自然"
    }
  ],
}